export const enum TranslationKey {
    cannotLogin = 'CANNOT_LOGIN',
    successfullyLoggedIn = 'SUCCESSFULLY_LOGGED_IN',
    name = 'NAME',
    firstName = 'FIRST_NAME',
    lastName = 'LAST_NAME',
    email = 'EMAIL',
    participantWithQRCodeNotFound = 'PARTICIPANT_WITH_QRCODE_NOT_FOUND',
    cannotUpdateParticipant = 'CANNOT_UPDATE_PARTICIPANT',
    participantUpdated = 'PARTICIPANT_UPDATED',
    printingStarted = 'PRINTING_STARTED',
    cannotPrint = 'CANNOT_PRINT',
    start = 'START',
    end = 'END',
    description = 'DESCRIPTION',
    details = 'DETAILS',
    summary = 'SUMMARY',
    stage = 'STAGE',
    status = 'STATUS',
    environmentFacing = 'ENVIRONMENT_FACING',
    userFacing = 'USER_FACING',
    badge = 'BADGE',
    badgeSetup = 'BADGE_SETUP',
    scanQRCode = 'SCAN_QR_CODE',
    print = 'PRINT',
    reports = 'REPORTS',
    printerSetup = 'PRINTER_SETUP',
    cantGetListOfPrinters = 'CANT_GET_LIST_OF_PRINTERS',
    handheldScannerSetup = 'HANDHELD_SCANNER_SETUP',
    addWalkIn = 'ADD_WALK_IN',
    activityFields = 'ACTIVITY_FIELDS',
    url = 'URL',
    speakerInfo = 'SPEAKER_INFO',
    room = 'ROOM',
    registration = 'REGISTRATION',
    waitinglist = 'WAITINGLIST',
    approval = 'APPROVAL',
    capacity = 'CAPACITY',
    products = 'PRODUCTS',
    display = 'DISPLAY',
    settings = 'SETTINGS',
    activityGroup = 'ACTIVITY_GROUP',
    activityCondition = 'ACTIVITY_CONDITION',
    createdAt = 'CREATED_AT',
    updatedAt = 'UPDATED_AT',
    arrivedAt = 'ARRIVED_AT',
    printerError = 'PRINTER_ERROR',
    kioskMode = 'KIOSK_MODE',
    deviceType = 'DEVICE_TYPE',
    deviceId = 'DEVICE_ID',
    badgesPrinted = 'BADGES_PRINTED',
    badgesAvailable = 'BADGES_AVAILABLE',
    badgesStackAdded = 'BADGES_STACK_ADDED',
    deviceStatus = 'DEVICE_STATUS',
    tearOffStatus = 'TEAR_OFF_STATUS',
    setAsCurrentEventMenuAction = 'SET_AS_CURRENT_EVENT',
    resetPasswordNotificationSuccess = 'RESET_PASSWORD_NOTIFICATION_SUCCESS',
    kioskLocation = 'KIOSK_LOCATION'
}

export const enum NotificationMessageType {
    info = 'info',
    success = 'success',
    warning = 'warning',
    error = 'error'
}

export const enum SettingEntityType {
    event = 'event',
    eventSeries = 'event_series',
    eventTemplate = 'event_template',
    participant = 'participant',
    activityParticipant = 'activity_participant',
    participantField = 'participant_field',
    organizationField = 'organization_field',
    contactField = 'contact_field',
    eventField = 'event_field',
    user = 'user',
    team = 'team',
    organization = 'organization',
    contact = 'contact',
    page = 'page',
    theme = 'theme',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    theme_team = 'theme_team',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    theme_assets = 'theme_assets',
    emailTemplate = 'emailtemplate',
    emailCampaign = 'email_campaign',
    emailCampaignAudience = 'email_campaign_audience',
    global = 'global',
    process = 'process',
    stage = 'stage',
    job = 'job',
    activity = 'activity',
    apiClient = 'api_client',
    engagementAppQuestion = 'engagement_app_question',
    engagementAppPoll = 'engagement_app_poll',
    engagementAppNewsfeed = 'engagement_app_newsfeed',
    crm = 'crm',
    integration = 'integration',
    tax = 'tax',
    cancellationTerms = 'cancellation_terms',
    product = 'product',
    productGroup = 'productGroup',
    order = 'order',
    discount = 'discount',
    location = 'location',
    room = 'room',
    amenity = 'amenity',
    floorPlan = 'floorPlan',
    roomSettings = 'roomSettings',
    roomBooking = 'roomBooking',
    report = 'report',
    version = 'version',
    genericWorkflow = 'generic_workflow',
    externalCrmLog = 'external_crm_log',
    participantAudit = 'participant_audit',
    headerAndFooterPages = 'header_and_footer_pages',
    emailHeaderAndFooterPages = 'email_header_and_footer_pages',
    badgeFont = 'badgeFont',
    profilePage = 'profile_page'
}

export const enum SettingParentType {
    event = 'event',
    participant = 'participant',
    series = 'series',
    report = 'report'
}

export const enum SettingType {
    advancedSearch = 'advanced_search',
    listingColumns = 'listing_columns',
    dashboard = 'dashboard',
    listingExport = 'listing_export',
    viewindex = 'viewindex'
}

export const enum CssClassName {
    bottomSheetPanel = 'bottom-sheet-panel',
    noTopToolbar = 'no-top-toolbar'
}

export const enum CheckinType {
    eventParticipant = 'eventParticipant',
    activityParticipant = 'activityParticipant'
}

export const enum RouteParamName {
    eventId = 'eventId',
    activityId = 'activityId'
}

export const enum IconName {
    qrCodeScanner = 'qr_code_scanner',
    badge = 'badge',
    print = 'print',
    barChart = 'bar_chart',
    chart = 'insert_chart',
    lightbulb = 'lightbulb',
    add = 'add',
    check_circle = 'check_circle'
}

export enum SwitchMode {
    badgePrintMode = 'badgePrintMode',
    checkInMode = 'checkInMode'
}

export const enum AocClassNamePrefix {
    aocAuto = 'aoc-auto'
}
